import { IStudentLogSelectRequest } from '../../models/request/y-te/yTeRequests';
import { studentlog } from '../../models/response/y-te/studentlog';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_STUDENT_LOG_PATH = 'student-log';

class StudentLogApi extends BaseCRUDApi<studentlog> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	Select(request: IStudentLogSelectRequest) {
		return apiClient.post(`${API_STUDENT_LOG_PATH}/select`, request);
	}
	/** `language` phải là 'vn' | 'en' (xem helper `toApiLanguage`) */
	Detail(id: number, language: string) {
		return apiClient.get(`${API_STUDENT_LOG_PATH}/${id}/language/${language}`);
	}
}
export const studentLogApi = new StudentLogApi(API_STUDENT_LOG_PATH);
